// removed by extract-text-webpack-plugin
module.exports = {"header_height":"65px"};